import React from "react";
import { merge } from "glamor";
import { theme } from "styles/theme";

interface IProps {
    className?: string;
    children: React.ReactNode;
}

const ProductCollectionStatusPill: React.FunctionComponent<IProps> = ({ children, className }) => {
    const styles = React.useMemo(
        () =>
            merge({
                backgroundColor: theme.palette.accent1Color,
                height: "20px",
                width: "auto",
                color: "white",
                fontSize: "12px",
                borderRadius: "3px",
                padding: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }),
        []
    );
    return (
        <span {...styles} className={className}>
            {children}
        </span>
    );
};

export { ProductCollectionStatusPill };
